"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagPH = function FlagPH(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-190.4,144.65,11.8,12.18-190.4-120.29a7,7,0,0,0-2.6,5.35V139.3a7,7,0,0,0,2.6,5.35Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-190.4,144.65a7,7,0,0,0,4.46,1.71H209.54a7.06,7.06,0,0,0,7.06-7.06V12.18H11.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-190.4-120.29a7,7,0,0,1,4.46-1.71H209.54a7.06,7.06,0,0,1,7.06,7.06V12.18H11.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-95.9,12.18a22.94,22.94,0,0,1-22.95,23,23,23,0,0,1-23-23,23,23,0,0,1,23-22.95,22.94,22.94,0,0,1,22.95,23Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-118.85,12.18l-8.61-34.43,8.61-11.47,8.61,11.47Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-118.85,12.18l8.61,34.43-8.61,11.47-8.61-11.47Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-118.85,12.18l-34.43,8.61-11.47-8.61,11.47-8.61Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-118.85,12.18l34.43-8.61,11.47,8.61-11.47,8.61Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-118.85,12.18l18.26-30.43,14.2-2-2,14.2Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-118.85,12.18-137.1,42.61l-14.21,2,2-14.2Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-118.85,12.18-149.28-6.08l-2-14.2,14.21,2Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-118.85,12.18l30.43,18.26,2,14.2-14.2-2Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-174.07-87.27l1.19,8.93-8.06,4a1.21,1.21,0,0,0,.33,2.28l8.86,1.63,1.33,8.91a1.21,1.21,0,0,0,2.27.39l4.28-7.93,8.89,1.49a1.21,1.21,0,0,0,1.07-2l-6.21-6.52,4.16-8a1.22,1.22,0,0,0-1.61-1.65l-8.12,3.89L-172-88.28a1.21,1.21,0,0,0-2.06,1Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-170.52,86.5-172,95.39l-8.89,1.44a1.21,1.21,0,0,0-.37,2.27l8,4.18-1.38,8.91a1.22,1.22,0,0,0,2.05,1l6.44-6.3,8,4.06a1.21,1.21,0,0,0,1.63-1.62l-4-8.08,6.34-6.39a1.21,1.21,0,0,0-1-2l-8.91,1.3-4.12-8a1.22,1.22,0,0,0-2.28.35Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-30.81-1-36,6.39l-8.65-2.52A1.21,1.21,0,0,0-46,5.76l5.4,7.21-5.06,7.45a1.21,1.21,0,0,0,1.39,1.83l8.53-2.91,5.51,7.12A1.22,1.22,0,0,0-28,25.7l-.14-9,8.48-3.05a1.21,1.21,0,0,0,0-2.3l-8.61-2.65-.28-9A1.21,1.21,0,0,0-30.81-1Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagPH;
exports["default"] = _default;